import {Directive, ElementRef, AfterViewInit, OnDestroy, Renderer2} from '@angular/core';

// off-canvas sidebar for mobile, and this is the trigger
@Directive({
  selector: '[myToggleOffcanvasNav]',
  standalone: false,
})
export class ToggleOffcanvasNavDirective implements AfterViewInit, OnDestroy {
  private clickListener: (() => void) | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    const navToggler = this.el.nativeElement;

    this.clickListener = this.renderer.listen(navToggler, 'click', (e: Event) => {
      // _sidebar.scss, _page-container.scss
      const body = document.getElementById('body');
      if (body) {
        body.classList.toggle('sidebar-mobile-open');
      }
      e.preventDefault();
    });
  }

  ngOnDestroy() {
    if (this.clickListener) {
      this.clickListener();
    }
  }
}
